/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ToggleButton from "../ToggleButton";
import ButtonRow from "../ButtonRow";
import styles from "./ControlPane.module.css";
import _ from "lodash";

const ControlPane = ({
  data,
  generatedParts,
  activeSelection,
  genderSelected,
  categorySelected,
}) => {
  const [activeOption, setActiveOption] = React.useState({
    id: 1,
    skin: "skin_001",
  });
  const [filterdList, setFilteredList] = React.useState([]);

  React.useEffect(() => {
    setActiveOption({ id: 1, skin: "skin_001" });
    activeSelection({ id: 1, skin: "skin_001" });
  }, [genderSelected, categorySelected]);

  React.useEffect(() => {
    //Filter and reassign IDs to the list
    const listFiltered = _.map(
      _.filter(data.data, function (item) {
        return item.gender === genderSelected.toLowerCase();
      }),
      (item, index) => {
        return (item = { id: index + 1, ...item });
      }
    );
    setFilteredList(listFiltered);

    //Set the active option for each of the control pane, then generate the parts
    const findPart = _.find(
      _.map(listFiltered, (item, index) => {
        return (item = { id: index + 1, ...item });
      }),
      function (item) {
        return item.id === activeOption.id;
      }
    );
    generatedParts(findPart);
  }, [activeSelection]);

  return (
    <div key={data.title} className={styles.controlPane}>
      <h6 className={styles.title}>
        {data.title}
        <span className={styles.metadata}>{filterdList.length} options</span>
      </h6>
      <ButtonRow>
        {filterdList.map(({ id, label, color, skin }) => (
          <ToggleButton
            key={id}
            isSelected={activeOption.id === id}
            onClick={() => {
              setActiveOption({ id, skin });
              activeSelection({ id, skin });
            }}
            label={label}
            color={color}
          >
            {id}
          </ToggleButton>
        ))}
      </ButtonRow>
    </div>
  );
};

export default ControlPane;
